/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CaretContainer_comment = {
    readonly id: string;
    readonly spamBanned: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"ModerationDropdownContainer_comment">;
    readonly " $refType": "CaretContainer_comment";
};
export type CaretContainer_comment$data = CaretContainer_comment;
export type CaretContainer_comment$key = {
    readonly " $data"?: CaretContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CaretContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerationDropdownContainer_comment"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spamBanned",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = 'b8779d03eb69c299ecb42c5c4309ff03';
export default node;
